// extracted by mini-css-extract-plugin
export var selected = "btn-dark-mode-module--selected--ee643";